export const getExtensionFile = (filename) => {
  if (filename) {
    // Menggunakan split() untuk memisahkan nama file dari ekstensinya
    const parts = filename.split(".");

    // Mengambil ekstensi dari elemen terakhir array
    const extension = parts[parts.length - 1];

    return extension;
  }
};
